import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.target');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-target',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.target/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.hn-target-page {
  max-width: 1120px;
}

.hn-current-chip {
  align-items: center;
  background: var(--hn-accent-soft);
  border: 1px solid #d6e5b8;
  border-radius: 13px;
  display: grid;
  gap: 3px 13px;
  grid-template-columns: auto auto;
  min-height: 54px;
  padding: 8px 13px;
}

.hn-current-chip > span {
  color: var(--hn-accent-deep);
  font-size: 13px;
  font-weight: 700;
  grid-row: 1/3;
}

.hn-current-chip strong {
  font-size: 15px;
  font-weight: 800;
}

.hn-current-chip small {
  color: var(--hn-muted);
  font-size: 13px;
  font-variant-numeric: tabular-nums;
}

.hn-target-feedback,
.hn-target-lock {
  align-items: center;
  border-radius: 13px;
  display: flex;
  gap: 13px;
  margin-top: 12px;
  min-height: 54px;
  padding: 11px 14px;
}

.hn-target-feedback {
  background: var(--hn-paper);
  border: 1px solid var(--hn-line);
}

.hn-target-feedback > span {
  animation: hn-target-pulse 0.8s ease-in-out infinite alternate;
  background: var(--hn-accent);
  border-radius: 50%;
  height: 10px;
  width: 10px;
}

.hn-target-feedback.is-error {
  justify-content: space-between;
}

.hn-target-feedback.is-error strong {
  color: var(--hn-danger);
  display: block;
}

.hn-target-feedback p {
  color: var(--hn-muted);
  font-size: 14px;
  margin: 4px 0 0;
}

.hn-target-feedback button {
  background: var(--hn-paper);
  border: 1px solid var(--hn-line-strong);
  border-radius: 9px;
  font-size: 14px;
  font-weight: 700;
  min-height: 44px;
  padding: 0 14px;
}

.hn-target-lock {
  background: #fff8ed;
  border: 1px solid #ead8ba;
  color: #795a2d;
}

.hn-target-lock strong {
  display: block;
  font-size: 14px;
}

.hn-target-lock p {
  color: #755d3a;
  font-size: 14px;
  line-height: 1.5;
  margin: 3px 0 0;
}

@keyframes hn-target-pulse {
  to {
    opacity: 0.3;
    transform: scale(0.78);
  }
}
.hn-target-layout {
  align-items: start;
  display: grid;
  gap: 12px;
  grid-template-columns: minmax(0, 1fr) 300px;
  margin-top: 12px;
}

.hn-approved-list,
.hn-selection-card {
  background: var(--hn-paper);
  border: 1px solid var(--hn-line);
  border-radius: var(--hn-radius-lg);
}

.hn-approved-list {
  min-width: 0;
  padding: 16px;
}

.hn-section-head {
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
  margin-bottom: 12px;
}

.hn-section-head h2 {
  font-size: 18px;
  margin: 0;
}

.hn-section-head p {
  color: var(--hn-muted);
  font-size: 14px;
  line-height: 1.5;
  margin: 6px 0 0;
}

.hn-section-head > span {
  background: var(--hn-paper-muted);
  border-radius: 8px;
  color: var(--hn-muted-strong);
  font-size: 14px;
  font-weight: 800;
  padding: 7px 9px;
}

.hn-approved-card {
  align-items: center;
  background: var(--hn-paper);
  border: 1px solid var(--hn-line-strong);
  border-radius: 12px;
  color: var(--hn-ink);
  display: grid;
  gap: 14px;
  grid-template-columns: 24px minmax(170px, 0.75fr) minmax(280px, 1.25fr) auto;
  min-height: 102px;
  padding: 14px;
  text-align: left;
  transition: border-color 0.16s var(--hn-ease), box-shadow 0.16s var(--hn-ease), transform 0.16s var(--hn-ease);
  width: 100%;
}

.hn-approved-card:hover {
  border-color: #9db765;
  transform: translateY(-1px);
}

.hn-approved-card.is-selected {
  background: var(--hn-accent-soft);
  border-color: #9db765;
  box-shadow: 0 0 0 3px rgba(168, 200, 93, 0.12);
}

.hn-stock-check {
  align-items: center;
  border: 1.5px solid var(--hn-line-strong);
  border-radius: 50%;
  color: transparent;
  display: flex;
  height: 21px;
  justify-content: center;
  width: 21px;
}

.hn-stock-check i {
  font-size: 10px;
}

.hn-approved-card.is-selected .hn-stock-check {
  background: var(--hn-accent-deep);
  border-color: var(--hn-accent-deep);
  color: #fff;
}

.hn-stock-main strong,
.hn-stock-main small {
  display: block;
}

.hn-stock-main strong {
  font-size: 21px;
  letter-spacing: -0.03em;
  margin-top: 8px;
}

.hn-stock-main small {
  color: var(--hn-muted);
  font-size: 13px;
  margin-top: 3px;
}

.hn-stock-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.hn-stock-badges em {
  background: var(--hn-accent-soft);
  border-radius: 7px;
  color: var(--hn-accent-deep);
  font-size: var(--hn-text-caption);
  font-style: normal;
  font-weight: 800;
  padding: 5px 7px;
}

.hn-approved-card.is-selected .hn-stock-badges em {
  background: rgba(255, 255, 255, 0.62);
}

.hn-stock-proof {
  display: grid;
  gap: 9px;
  margin: 0;
}

.hn-stock-proof div {
  align-items: center;
  display: flex;
  gap: 16px;
  justify-content: space-between;
}

.hn-stock-proof dt {
  color: var(--hn-muted);
  font-size: 13px;
}

.hn-stock-proof dd {
  font-size: 14px;
  font-weight: 700;
  margin: 0;
  text-align: right;
}

.hn-current-label {
  background: var(--hn-charcoal);
  border-radius: 8px;
  color: #fff;
  font-size: var(--hn-text-caption);
  font-weight: 800;
  padding: 7px 9px;
}

.hn-approved-empty {
  align-items: center;
  border: 1px dashed var(--hn-line-strong);
  border-radius: 14px;
  color: var(--hn-muted);
  display: flex;
  flex-direction: column;
  min-height: 145px;
  justify-content: center;
  padding: 20px 16px;
  text-align: center;
}

.hn-approved-empty > i {
  color: var(--hn-accent-deep);
  font-size: 22px;
  margin-bottom: 13px;
}

.hn-approved-empty strong {
  color: var(--hn-ink);
  font-size: 16px;
}

.hn-approved-empty p {
  font-size: 14px;
  line-height: 1.55;
  margin: 7px 0 0;
}

.hn-selection-card {
  background: radial-gradient(circle at 90% 0, rgba(169, 201, 92, 0.15), transparent 210px), var(--hn-charcoal);
  border-color: rgba(255, 255, 255, 0.08);
  box-shadow: var(--hn-shadow-md);
  color: #fff;
  overflow: hidden;
  padding: 17px;
  position: sticky;
  top: 20px;
}

.hn-selection-card > header {
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.62);
  display: flex;
  font-size: 13px;
  font-weight: 700;
  gap: 8px;
  padding-bottom: 12px;
}

.hn-selection-card > header i {
  color: var(--hn-accent);
}

.hn-selection-content > strong {
  display: block;
  font-size: 25px;
  letter-spacing: -0.04em;
  margin-top: 17px;
}

.hn-selection-content > small {
  color: rgba(255, 255, 255, 0.62);
  display: block;
  font-size: 13px;
  margin-top: 5px;
}

.hn-selection-content > p {
  color: rgba(255, 255, 255, 0.72);
  font-size: 14px;
  line-height: 1.45;
  margin: 12px 0 0;
}

.hn-selection-card button {
  align-items: center;
  background: var(--hn-accent);
  border: 1px solid #91ad4e;
  border-radius: 10px;
  color: var(--hn-accent-ink);
  display: flex;
  font-size: 14px;
  font-weight: 800;
  gap: 10px;
  justify-content: center;
  margin-top: 17px;
  min-height: 46px;
  padding: 0 16px;
  width: 100%;
}

.hn-selection-card button:disabled {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.38);
}

.hn-selection-empty {
  padding-top: 16px;
}

.hn-selection-empty strong {
  display: block;
  font-size: 17px;
}

.hn-selection-empty p {
  color: rgba(255, 255, 255, 0.52);
  font-size: 13px;
  line-height: 1.55;
  margin: 8px 0 0;
}

.hn-mobile-selection {
  display: none;
}

@media (max-width: 1050px) {
  .hn-approved-card {
    grid-template-columns: 24px minmax(0, 1fr) auto;
  }
  .hn-stock-proof {
    grid-column: 2/4;
  }
}
@media (max-width: 900px) {
  .hn-target-page.has-mobile-selection {
    padding-bottom: calc(156px + env(safe-area-inset-bottom));
  }
  .hn-target-layout {
    grid-template-columns: 1fr;
  }
  .hn-selection-card {
    display: none;
  }
  .hn-mobile-selection {
    align-items: center;
    background: var(--hn-charcoal);
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 13px;
    bottom: calc(76px + env(safe-area-inset-bottom));
    box-shadow: 0 18px 50px rgba(18, 21, 18, 0.28);
    color: #fff;
    display: flex;
    gap: 14px;
    justify-content: space-between;
    left: 12px;
    padding: 10px 10px 10px 16px;
    position: fixed;
    right: 12px;
    z-index: 25;
  }
  .hn-mobile-selection small,
  .hn-mobile-selection strong {
    display: block;
  }
  .hn-mobile-selection small {
    color: rgba(255, 255, 255, 0.68);
    font-size: 14px;
  }
  .hn-mobile-selection strong {
    font-size: 15px;
    margin-top: 3px;
  }
  .hn-mobile-selection button {
    background: var(--hn-accent);
    border: 1px solid #91ad4e;
    border-radius: 9px;
    color: var(--hn-accent-ink);
    font-size: 14px;
    font-weight: 800;
    min-height: 46px;
    min-width: 94px;
    padding: 0 14px;
  }
}
@media (max-width: 650px) {
  .hn-current-chip {
    justify-self: stretch;
    width: 100%;
  }
  .hn-approved-list {
    padding: 14px 12px;
  }
  .hn-section-head {
    gap: 14px;
  }
  .hn-approved-card {
    align-items: start;
    gap: 11px;
    grid-template-columns: 22px minmax(0, 1fr);
    padding: 13px 12px;
  }
  .hn-current-label {
    grid-column: 2;
    justify-self: start;
  }
  .hn-stock-proof {
    grid-column: 2;
    width: 100%;
  }
  .hn-stock-proof div {
    align-items: flex-start;
    flex-direction: column;
    gap: 3px;
  }
  .hn-stock-proof dd {
    text-align: left;
  }
  .hn-target-feedback.is-error {
    align-items: stretch;
    flex-direction: column;
  }
}`],
})
export class PageTargetComponent implements OnInit {
    public currentTarget: any = null;
    public selectedCandidate: any = null;
    public saving = false;
    public candidates: any[] = [];
    public targetChange: any = { allowed: true, reason: '', cycle_id: null };
    public loading = true;
    public loadError = '';

    constructor(@Inject( Service) public service: Service) { }

    public get canChangeTarget() {
        return this.targetChange?.allowed !== false;
    }

    public get targetChangeReason() {
        return this.targetChange?.reason || '진행 중인 사이클과 주문을 먼저 확인해주세요.';
    }

    public get saveButtonLabel() {
        if (this.saving) return '저장 중';
        if (!this.canChangeTarget) return '변경 잠김';
        if (this.currentTarget?.code === this.selectedCandidate?.code) return '현재 운용 종목';
        return '이 종목으로 선택';
    }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');
        await this.load();
    }

    public async load() {
        this.loading = true;
        this.loadError = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('get');
            if (code !== 200 || !data) {
                throw new Error((data && data.message) || '잠시 후 다시 시도해주세요.');
            }
            this.candidates = data.candidates || [];
            this.targetChange = data.target_change || this.targetChange;
            this.currentTarget = data.target || null;
            this.selectedCandidate = this.currentTarget
                ? this.candidates.find((item: any) => item.code === this.currentTarget.code) || this.currentTarget
                : this.candidates[0] || null;
        } catch (error: any) {
            this.loadError = error?.message || '잠시 후 다시 시도해주세요.';
        } finally {
            this.loading = false;
            await this.service.render();
        }
    }

    public async selectCandidate(candidate: any) {
        this.selectedCandidate = candidate;
        await this.service.render();
    }

    public shortVersion(version: string) {
        const match = String(version || '').match(/v\d+(?:\.\d+)?/i);
        return match ? match[0].toLowerCase() : '승인 전략';
    }

    public async saveTarget() {
        if (!this.selectedCandidate || this.saving) return;
        if (!this.canChangeTarget) {
            await this.service.modal.error(this.targetChangeReason);
            return;
        }
        if (this.currentTarget?.code === this.selectedCandidate.code) return;

        const confirmed = await this.service.modal.warning(
            this.selectedCandidate.name + '을 다음 새 사이클의 운용 종목으로 선택할까요?',
            '취소',
            '선택'
        );
        if (!confirmed) return;

        this.saving = true;
        await this.service.render();
        try {
            const payload = {
                code: this.selectedCandidate.code,
                confirmation: this.selectedCandidate.code
            };
            const { code, data } = await wiz.call('save', payload);
            if (code !== 200 || !data?.target) {
                if (data?.target_change) this.targetChange = data.target_change;
                await this.service.modal.error((data && data.message) || data || '종목을 저장하지 못했습니다.');
                return;
            }
            this.currentTarget = data.target;
            this.targetChange = data.target_change || this.targetChange;
            await this.service.modal.success(data.target.name + '을 운용 종목으로 저장했습니다.');
        } catch (error) {
            await this.service.modal.error('종목 저장 요청을 완료하지 못했습니다.');
        } finally {
            this.saving = false;
            await this.service.render();
        }
    }
}

export default PageTargetComponent;